import Sagas from 'modules/User/Profile/store/saga'
import Reducer from 'modules/User/Profile/store/reducer'
import Profile from 'modules/User/Profile/Profile'

export default Profile

export { Sagas, Reducer }
